import PropTypes from 'prop-types';

export const EndOfDayShipmentPropType = PropTypes.shape({
  items: PropTypes.number,
  shipped: PropTypes.number,
  shipmentId: PropTypes.number,
  carrierId: PropTypes.number,
  providerId: PropTypes.number,
  warehouseId: PropTypes.number,
  sellerProviderId: PropTypes.number,
  orderNumber: PropTypes.string,
  carrierName: PropTypes.string,
  providerName: PropTypes.string,
  recipient: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  country: PropTypes.string,
  warehouseName: PropTypes.string,
});

/**
 * @typedef {object} EndOfDayShipmentPropType
 * @property {number} items
 * @property {number} shipped
 * @property {number} shipmentId
 * @property {number} carrierId
 * @property {number} providerId
 * @property {number} warehouseId
 * @property {number} sellerProviderId
 * @property {string} orderNumber
 * @property {string} carrierName
 * @property {string} providerName
 * @property {string} recipient
 * @property {string} city
 * @property {string} state
 * @property {string} country
 * @property {string} warehouseName
 */
